export default __webpack_public_path__ + "static/media/prev-C1A-4.d623f64d.png";